import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=2f850d33&scoped=true&"
import script from "./LoadingIndicator.vue?vue&type=script&lang=ts&"
export * from "./LoadingIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingIndicator.vue?vue&type=style&index=0&id=2f850d33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f850d33",
  null
  
)

export default component.exports